$(document).on('click','.u_nav_search_icon',function(){
    console.log('click')
  $('.u_nav_search_wrapper').toggleClass('hide')
})
 $(document).on('click', 'body',function(e){
    console.log('body click  per')
           $('.u_nav_search_wrapper').addClass('hide')
  });
   $(document).on('click','.u_nav_search_wrapper,.u_nav_search',function(e){
    console.log('stop propagation per')
    e.stopPropagation();
  })
  $(document).on('keyup','.u_search_inp',function(){
    let searchTerm = $(this).val();
    console.log('keyup',searchTerm.length)
    if(searchTerm.length != 0){
      console.log('if condition',searchTerm.length)
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=query,product,collection,page,article&section_id=predictive-search`)
    .then((response)=>{
      if(response.status == '200'){
      return response.text()        
      }

    })
    .then((resolve)=>{
      setTimeout(function(){
          $('.u_search_r_arrow').show()    
      $('.u_predictive_body').show().html(resolve)        
      },1000)
    }).
      catch((err)=>{
       console.log('error',err) 
      })
}
  else{
          console.log('if condition',searchTerm.length)
  }
})